import SectionIcon from './SectionIcon';
import MenuSelector from './MenuSelector';

export default function CombinationSection({ values, setFieldValue, readonly = false }) {
  const handleAddRecommendedMenu = (menu) => {
    const current = values.recommendedMenus || [];
    const menuExists = !!current.some((m) => m._id === menu._id);
    if (!menuExists) {
      setFieldValue('recommendedMenus', [...current, menu]);
    }
  };

  const handleRemoveRecommendedMenu = (menuId) => {
    const current = values.recommendedMenus || [];
    setFieldValue(
      'recommendedMenus',
      current.filter((m) => m._id !== menuId),
    );
  };

  const handleAddAvoidMenu = (menu) => {
    const current = values.avoidSimultaneousMenus || [];
    const menuExists = !!current.some((m) => m._id === menu._id);
    if (!menuExists) {
      setFieldValue('avoidSimultaneousMenus', [...current, menu]);
    }
  };

  const handleRemoveAvoidMenu = (menuId) => {
    const current = values.avoidSimultaneousMenus || [];
    setFieldValue(
      'avoidSimultaneousMenus',
      current.filter((m) => m._id !== menuId),
    );
  };

  return (
    <div className="px-4 py-8 border-b border-slate-50">
      <SectionIcon title="併用・相性管理">
        <span className="material-symbols-outlined text-primary text-xl">layers</span>
      </SectionIcon>

      <div className="space-y-5">
        <MenuSelector
          label="併用おすすめメニュー"
          selectedMenus={values.recommendedMenus || []}
          onAdd={handleAddRecommendedMenu}
          onRemove={handleRemoveRecommendedMenu}
          icon="add"
          readonly={readonly}
        />

        <MenuSelector
          label="同時施術NGメニュー"
          selectedMenus={values.avoidSimultaneousMenus || []}
          onAdd={handleAddAvoidMenu}
          onRemove={handleRemoveAvoidMenu}
          icon="remove"
          readonly={readonly}
        />
      </div>
    </div>
  );
}
